module.exports = __webpack_public_path__ + "img/UM.36d85ede.png";